/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBWALLETLIST, GETCLUBWALLETTYPE, GETSELECTWALLET } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBWALLETLIST:
      return Object.assign({}, state, { clubWalletList: action.payload })
    case GETCLUBWALLETTYPE:
      return Object.assign({}, state, { walletType: action.payload })
    case GETSELECTWALLET:
      return Object.assign({}, state, { selectWallet: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubWallet/reduce.js